import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";
import { Project } from "../data/projects";
import ProjectLinkTag from "./ProjectLinkTag";

const ProjectCard: React.FC<{ project: Project }> = ({ project }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
      className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-sm"
    >
      <h3 className="font-medium">{project.name}</h3>
      <p className="mt-2 text-sm text-gray-300">{project.desc}</p>
      <div className="mt-5 flex flex-wrap gap-2">
        {project.techstack.map((sk) => (
          <motion.span
            variants={itemUp}
            key={sk}
            whileHover={{ scale: 1.05 }}
            className="text-sm px-3 py-2 bg-white/10 border border-white/20 rounded-md shadow-sm"
          >
            {sk}
          </motion.span>
        ))}
      </div>
      <div className="mt-6 flex flex-wrap gap-3">
        {project.links.map((link) => (
          <ProjectLinkTag projectLink={link} />
        ))}
      </div>
    </motion.div>
  );
};

export default ProjectCard;
